import { SimpleFormProps } from 'app/infrastructure/simple-form/types';
import { DefaultContainerProps } from 'app/infrastructure/redux/types';
import { PromptProps } from 'app/components/prompt-unsaved/prompt-unsaved';
import { actionCreators } from './actions';
import { OptionsProps } from 'app/components/options-handler';
import { AdministrationUserEditState } from 'app/area/administration/edit/user/types-store';
import { UserMessage } from 'app/types-shared';

export interface UserDataFactoryProps {
  title: string;
  saveButtonText: string;
  showUserEditMenu?: boolean;
  hideDetails?: boolean;
  showPersonId?: boolean;
  showUserId?: boolean;
  duplicateUrl?: string;
  onLoadUser?: () => void;
  onSave: () => void;
}

export interface AdministrationUserEditPropsExternalProps {
  id: number;
  editMode: boolean;
  shouldDisplayModal: boolean;
  optionsFetching: boolean;
  section: string;
}

export type AdministrationUserEditProps = AdministrationUserEditPropsExternalProps
  & AdministrationUserEditState & SimpleFormProps & DefaultContainerProps & PromptProps & typeof actionCreators
  & OptionsProps & UserDataFactoryProps;

export enum UserEditSectionType {
  Details = 'details',
  AccessToOperation = 'accessToOperation',
  AccessToScreen = 'accessToScreen',
  ExtendedAccess = 'extendedAccess',
  RestrictedAccess = 'restrictedAccess',
  AccessToAdministrateUserGroup = 'accessToAdministrateUserGroup',
  AccessToAssignRoles = 'accessToAssignRoles',
  DefaultValues = 'defaultValues',
  UserOccurence = 'userOccurence',
  Notifications = 'notifications',
  ExperienceTransferAlerts = 'experienceTransferAlerts'
}

export interface UserInfoNotification {
  show: boolean;
  message: string | UserMessage[];
}
